import { Stage } from "./Stage";
import { Speech } from "./TalkPanel";

export class Stage1 extends Stage {
    constructor() {
        super();
        this.pushCheckPoint(50, 50);
        this.pushPlayer(50, 50);
        this.asCameraCenter();
        this.pushDescription(50, -250, 100, 100, "↑");
        this.s$fontSize = 12;
        this.pushWall(-600, -400, 400, 400);
        this.pushWall(-200, -1200, 200, 1000);
        this.pushWall(0, -800, 200, 100);
        this.pushWall(200, -1200, 400, 1000);
        this.pushWall(400, -200, 1000, 200);
        this.pushWall(400, 200, 200, 200);
        this.pushWall(600, -400, 200, 200);
        this.pushWall(200, 400, 400, 1000);
        this.pushWall(800, 200, 800, 200);
        this.pushWall(1400, 0, 200, 200);
        this.pushWall(1400, -400, 200, 200);
        this.pushWall(1000, -400, 200, 200);
        this.pushWall(600, 600, 600, 200);
        this.pushWall(600, -1200, 1400, 600);
        this.pushWall(1800, -600, 200, 1600);
        this.pushWall(1400, 600, 400, 400);
        this.pushWall(800, 1000, 1000, 200);
        this.pushWall(600, 1200, 800, 200);
        this.pushWall(1200, 1400, 200, 400);
        this.pushWall(200, 1800, 1200, 200);
        this.pushWall(-1200, 1600, 1400, 400);
        this.pushWall(-1400, 600, 200, 1400);
        this.pushFakePanel(-1200, 600, 400, 200);
        this.pushWall(-800, 600, 800, 200);
        this.pushWall(-400, 400, 400, 200);
        this.pushWall(-600, 200, 400, 200);
        this.pushWall(-1600, 0, 200, 800);
        this.pushWall(-1400, 0, 600, 400);
        this.pushSquare(-1200, -200, 400, 200);
        this.pushWall(-1200, -1200, 400, 1000);
        this.pushWall(-1600, -1600, 2800, 200);
        this.pushWall(1000, -1400, 200, 200);
        this.pushWall(-800, -1200, 400, 600);
        this.pushWall(-400, -1200, 200, 400);
        this.pushWall(-1600, -1400, 200, 1200);
        this.pushWall(-2000, -400, 400, 200);
        this.pushWall(-2000, -200, 200, 200);
        this.pushWall(-2000, 0, 400, 200);
        this.pushWall(-1000, 1000, 400, 400);
        this.pushWall(-400, 1000, 400, 400);
        this.pushSquare(200, 1400, 400, 400);
        this.pushFakePanel(1600, -600, 200, 200);
        this.pushFakePanel(1200, -600, 200, 200);
        this.pushSquare(800, -600, 200, 200);
        this.pushSignboard(50, -650, [
            new Speech({
                content: '上に見えるは<font style="color:#00dd00">記憶の穴</font>です。',
                speakerName: "看板",
            }),
            new Speech({
                content: "あら、あっさり見つかったわね。",
                speakerName: "謎の声",
            }),
            new Speech({
                content: "見つかりはしたがどうやって行くんだ？",
            }),
            new Speech({
                content: '壁のなかには<font style="color:#00dd00">動かせる壁</font>と<font style="color:#00dd00">通れる壁</font>があります。',
                speakerName: "看板",
            }),
            new Speech({
                content: "どこからも繋がっていなくていけない場所は注意深くさがしてみましょう。",
                speakerName: "看板",
            }),
        ]);
        this.pushSignboard(850, -550, [
            new Speech({
                content: '<font style="color:#dd0000">自分が好きな食べ物は、なにかを揚げたものだ。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushSignboard(650, 1450, [
            new Speech({
                content: '<font style="color:#dd0000">自分が好きな食べ物は鶏肉を使っている。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushSignboard(-1350, 450, [
            new Speech({
                content: "ここのほぼ真下には親切な矢印がいますよ。",
                speakerName: "看板",
            }),
            new Speech({
                content: "ここから下の方に行くには回り道する必要がありそうだ。",
            }),
        ]);
        this.pushSignboard(-350, -1350, [
            new Speech({
                content: '<font style="color:#dd0000">自分が好きな食べ物は四文字だ。</font>',
                speakerName: "記憶の欠片",
            }),
        ]);
        this.pushSignboard(-350, -750, [
            new Speech({
                content: 'ここに来るまでに<font style="color:#00dd00">記憶の穴</font>への道があったはずですよ。',
                speakerName: "看板",
            }),
            new Speech({
                content: "あら、あったかしら。",
                speakerName: "謎の声",
            }),
            new Speech({
                content: "どこかの壁が押せるか通れるのだろうか。",
            }),
        ]);
        this.pushSquare(-200, -1400, 800, 200);
        this.pushDescription(-1550, 1450, 100, 100, "→");
        this.s$fontSize = 12;
        this.pushDescription(-600, -1400, 200, 200, "→");
        this.s$fontSize = 12;

        this.pushGoal(50, -950, 100, 100);

        // this.pushCheckPoint(700, -200);
        // this.respawnCheckPoint(1);

        this.create();
    }

    protected loop(): void {}
}
